module.exports = __webpack_public_path__ + "static/img/qq_2.c20e5c62.png";